import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SubscriptionsPage = Loadable(lazy(() => import("./SubscriptionsPage")));

const subscriptionRoutes = [
  { path: "/subscriptions", element: <SubscriptionsPage /> },
];

export default subscriptionRoutes;
